import { type ITranslationMapHandler } from '@principle-theorem/practice-migrations/interfaces';
import { resolveSequentially, WithRef } from '@principle-theorem/shared';

export class MappedItemFinder {
  static async findUnmappedItems<T extends object>(
    translationMap: ITranslationMapHandler,
    items: WithRef<T>[],
    resourceType: string
  ): Promise<WithRef<T>[]> {
    const unmappedItems: WithRef<T>[] = [];
    await resolveSequentially(items, async (item) => {
      const mapping = await translationMap.getByDestination<T>(
        item.ref,
        resourceType
      );
      if (!mapping) {
        unmappedItems.push(item);
      }
    });
    return unmappedItems;
  }
}
